import { LightType, IVector3 } from '@inter-ikea-betrakta/viewer';
import { defaultRenderSettings } from '../config/defaultRenderSettings';
export class LightsApi {
    constructor(ipexViewer, renderSettings = defaultRenderSettings) {
        this.ipexViewer = ipexViewer;
        this.renderSettings = renderSettings;
        this.mainLight = null;
    }
    async setupSceneLights() {
        await this.setupEnvironmentMap();
        this.setupMainLightIfNeeded();
        this.setupTemporalEffects();
        this.setupEnvironmentmapValues();
        this.setupCameraExposure();
    }
    async setupEnvironmentMap() {
        await this.ipexViewer.set_environment_map(this.renderSettings.environmentMap.url);
    }
    setupMainLightIfNeeded() {
        if (!this.mainLight) {
            this.setupMainLight();
        }
        else {
            // If the main light is already created, we need to update its position
            this.centerLights(this.renderSettings.mainLight.position);
        }
    }
    setupTemporalEffects() {
        // Enable temporal effects
        this.ipexViewer.enable_temporal_effects(this.renderSettings.temporalEffects.screenSpaceAmbientOcclusion &&
            this.renderSettings.temporalEffects.temporalAntiAliasing);
    }
    setupCameraExposure() {
        const exposureValue = Math.log2(0.5);
        this.ipexViewer.set_camera_exposure(exposureValue);
    }
    setupEnvironmentmapValues() {
        this.ipexViewer.set_environment_map_rotation_radians(this.renderSettings.environmentMap.rotation);
        this.ipexViewer.set_environment_map_local_mode(this.renderSettings.environmentMap.localMode);
        this.ipexViewer.set_environment_map_intensity(this.renderSettings.environmentMap.intensity);
    }
    setupMainLight() {
        this.mainLight = this.ipexViewer.create_light(LightType.SPOT_LIGHT);
        this.mainLight.position = new IVector3(this.renderSettings.mainLight.position.x, this.renderSettings.mainLight.position.y, this.renderSettings.mainLight.position.z);
        this.mainLight.intensity = this.renderSettings.mainLight.intensity;
        this.mainLight.outer_angle_degrees = this.renderSettings.mainLight.outerAngleDegrees;
        this.mainLight.inner_angle_degrees = this.renderSettings.mainLight.innerAngleDegrees;
        this.mainLight.shadow.shadow_near = this.renderSettings.mainLight.shadow.shadowNear;
        this.mainLight.shadow.shadow_far = this.renderSettings.mainLight.shadow.shadowFar;
        this.mainLight.shadow.shadow_resolution = this.renderSettings.mainLight.shadow.shadowResolution;
        this.mainLight.shadow.enable_shadows = true;
        this.mainLight.shadow.set_bias(this.renderSettings.mainLight.shadow.bias);
        this.mainLight.set_color_temperature(this.renderSettings.mainLight.colorTemperature);
    }
    centerLights(position) {
        if (this.mainLight) {
            this.mainLight.position = new IVector3(position.x, this.renderSettings.mainLight.position.y, position.z);
        }
    }
    setShadowsEnabled(enabled) {
        if (this.mainLight) {
            this.mainLight.shadow.enable_shadows = enabled;
        }
    }
    updatePointLight(intensity) {
        this.pointLight.intensity = intensity;
    }
    forAssembly(status) {
        if (status) {
            if (this.mainLight)
                this.ipexViewer.delete_light(this.mainLight);
        }
        else {
            this.setupSceneLights();
        }
    }
    setDarkScene() {
        this.ipexViewer.set_environment_map_intensity(this.renderSettings.darkMode.environmentMapIntensity);
        if (this.mainLight) {
            this.ipexViewer.delete_light(this.mainLight);
            this.mainLight = null;
        }
        this.ipexViewer.set_bloom(true, 10);
        this.ipexViewer.set_temporal_ao_parameters({
            enabled: this.renderSettings.darkMode.temporalEffects.screenSpaceAmbientOcclusion &&
                this.renderSettings.darkMode.temporalEffects.temporalAntiAliasing,
            radius: this.renderSettings.darkMode.temporalEffects.ssaoParams.radius,
            strength: this.renderSettings.darkMode.temporalEffects.ssaoParams.ambientOccluionStrength,
            quality: this.renderSettings.darkMode.temporalEffects.quality
        });
        this.ipexViewer.enable_temporal_effects(this.renderSettings.darkMode.temporalEffects.screenSpaceAmbientOcclusion &&
            this.renderSettings.darkMode.temporalEffects.temporalAntiAliasing);
    }
    setLightScene() {
        this.ipexViewer.set_environment_map_intensity(this.renderSettings.environmentMap.intensity);
        this.setupMainLight();
        this.ipexViewer.enable_temporal_effects(this.renderSettings.temporalEffects.screenSpaceAmbientOcclusion &&
            this.renderSettings.temporalEffects.temporalAntiAliasing);
        this.ipexViewer.set_bloom(false);
    }
}
//# sourceMappingURL=LightsApi.js.map